var _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMonaManLogoMobile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 129.37 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #212529;\n        fill-rule: evenodd;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M0,.53H6.95l3.35,14.07h.05L13.81,.53h6.86V19.47h-4.47V4.76h-.05l-3.75,14.71h-4.18L4.36,4.76h-.05v14.71H0V.53ZM0,.53"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M31.4,3.99c-2.77,0-4.84,1.75-4.84,6.01,0,2.77,1.12,6.01,4.84,6.01,3.51,0,4.84-3.09,4.84-6.01s-1.33-6.01-4.84-6.01m0,16.01c-6.04,0-9.58-4.68-9.58-10S25.35,0,31.4,0s9.58,4.68,9.58,10-3.54,10-9.58,10"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M42.22,.53h4.79l6.89,12.1h.05V.53h4.31V19.47h-4.74l-6.95-11.91h-.05v11.91h-4.31V.53Zm0,0"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M70.45,12.98l-2.34-7.82h-.05l-2.34,7.82h4.74ZM65.58,.53h4.9l7.16,18.94h-5.08l-.96-2.98h-7l-.96,2.98h-5.06L65.58,.53Zm0,0"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M80.97,.53h2.21l6.15,15.85h.05L95.53,.53h2.21V19.47h-1.81V3.99h-.05l-5.91,15.48h-1.22l-5.91-15.48h-.05v15.48h-1.81V.53Zm0,0"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M109.84,12.29l-3.51-9.33-3.62,9.33h7.13Zm-2.69-11.75l7.35,18.94h-1.94l-2.13-5.69h-8.33l-2.26,5.69h-1.86L105.69,.53h1.46Zm0,0"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M114.89,.53h1.78l10.83,15.9h.05V.53h1.81V19.47h-1.78l-10.83-15.9h-.05v15.9h-1.81V.53Zm0,0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMonaManLogoMobile);
export default __webpack_public_path__ + "static/media/MonaMan Logo Mobile.ef9b47e53525e8976252f859b3e0dad8.svg";
export { ForwardRef as ReactComponent };